<a
  [target]="linkTarget"
  [link]="linkUrl"
  [style.color]="isCurrentRoute(linkUrl) ? (activeTextColor | contentBuilderColor) : (textColor | contentBuilderColor)"
  [ngClass]="{ 'font-bold': isCurrentRoute(linkUrl) }"
  class="flex items-center justify-center h-full"
>
  {{ text }}
</a>
